import { Button, Drawer, Radio } from "antd";
import React from "react";

const radioStyle = {
    display: "block",
    height: "30px",
    lineHeight: "30px",
};

export function ColorPaletteDrawer({
    isDrawerVisible,
    themePermissions,
    colorPickers,
    allUser,
    themeSelected,
    onClose,
    handleAllUserChange,
    handleThemeChange,
}) {
    // const [color, setColor] = useState(colorPalette);

    // useEffect(() => {
    //     setColor(colorPalette);
    // }, [colorPalette]);

    // const handleChange = (color) => {
    //     setColor(color);
    //     onColorChange(color);
    // };

    return (
        <Drawer
            title="Configurar Grafismo"
            placement="right"
            closable={false}
            onClose={onClose}
            visible={isDrawerVisible}
        >
            {themePermissions.find((item) => item.descricao === "paleta_cores_admin") && (
                <>
                    <h3>Para todos utilizadores?</h3>
                    <Radio.Group onChange={(e) => handleAllUserChange(e.target.value)} value={allUser}>
                        <Radio style={radioStyle} value={"s"}>
                            Sim
                        </Radio>
                        <Radio style={radioStyle} value={"n"}>
                            Não
                        </Radio>
                    </Radio.Group>
                </>
            )}
            <h3>Personalizar Tema</h3>
            {colorPickers}
            <h3>Temas predefinidos</h3>
            <Radio.Group onChange={(e) => handleThemeChange(e.target.value, allUser)} value={themeSelected}>
                <Radio style={radioStyle} value={2}>
                    Vermelho
                </Radio>
                <Radio style={radioStyle} value={3}>
                    Verde
                </Radio>
                <Radio style={radioStyle} value={4}>
                    Azul
                </Radio>
            </Radio.Group>
            <h3>Redefinir Tema</h3>
            <Button type="danger" ghost onClick={() => handleThemeChange(1, allUser)}>
                Redefinir
            </Button>
        </Drawer>
    );
}
